import firebase from 'firebase';
import Events from '../_utils/events.js';

class MatchesService extends Events {

	/*constructor() {
		super();
	}*/

	toArrayWithIds(__matches) {
		let
		matches = [];

		__matches.forEach(__match => {
			matches.push(_.extend({matchId: __match.key}, __match.val()));
		});

		return matches;
	}
}

let matchesService = new MatchesService();

export default matchesService;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_services/matches.service.js